'use strict';

var TRIM_CHARS = require('../../common/var/TRIM_CHARS');

module.exports = RegExp('(?=[' + TRIM_CHARS + '])');


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/TRUNC_REG.js
// module id = 949
// module chunks = 0